export default "__VITE_ASSET__C5C5icei__"